import { useEffect } from "react";

/**
 * PageSchema — mount a JSON-LD <script> in <head> for the lifetime of the
 * current page. Automatically cleans up on unmount or when `data`/`id` change,
 * so route transitions don't stack stale schemas.
 *
 * Usage:
 *   <PageSchema id="ld-sermons-list" data={{ "@context": "...", ... }} />
 *
 * `data` can be a single object or an array (rendered as @graph).
 */
export default function PageSchema({ id, data }) {
  useEffect(() => {
    if (!id || !data) return undefined;
    const payload = Array.isArray(data)
      ? { "@context": "https://schema.org", "@graph": data }
      : data;
    let el = document.getElementById(id);
    if (!el) {
      el = document.createElement("script");
      el.type = "application/ld+json";
      el.id = id;
      document.head.appendChild(el);
    }
    try {
      el.textContent = JSON.stringify(payload);
    } catch {
      /* ignore serialization errors */
    }
    return () => {
      const stale = document.getElementById(id);
      if (stale) stale.remove();
    };
  }, [id, data]);
  return null;
}
